import { ReactNode } from 'react'
import { Box, useMantineTheme } from '@mantine/core'

export type Props = {
    children: ReactNode
}

const Footer = (p: Props) => {
    const { colors } = useMantineTheme()

    return (
        <Box
            role="footer"
            aria-label="Cart Footer"
            data-testid="cart-footer"
            style={{
                borderTop: '1px solid' + colors.gray[2],
                backdropFilter: 'blur(14px)',
            }}
            className="sticky bottom-0 left-0 z-50 flex flex-col items-end w-full p-4 text-xs bg-white bg-opacity-75"
            aria-level={3}
        >
            {p.children}
        </Box>
    )
}

export default Footer
